import { createAction, props } from '@ngrx/store';

export const loadingActionType = '[Global] setLoading';

export const loadingAction = createAction(
	loadingActionType,
	props<{ loading: boolean }>()
);